import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Section, SectionContent } from '../components/utility/section';
import ProjectList from '../components/project/project-list';
import SEO from '../components/seo';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GatsbySite } from '../graphql';
import { defaultTransition } from '../styles/animation';

const ProjectsPage = () => {
  const { site } = useStaticQuery<GatsbySite>(
    graphql`
      query {
        site {
          siteMetadata {
            projects {
              name
              description
              imageName
              link
            }
          }
        }
      }
    `,
  );
  return (
    <>
      <SEO title="Projects" />
      <TopSection>
        <SectionContent>
          <motion.h1
            animate={{ x: 0, opacity: 1 }}
            initial={{ x: 50, opacity: 0 }}
            transition={defaultTransition}
          >
            It's not impossible, it's awesome...
          </motion.h1>
        </SectionContent>
      </TopSection>
      <Section>
        <SectionContent>
          <ProjectList projects={site.siteMetadata?.projects!} />
        </SectionContent>
      </Section>
    </>
  );
};

const TopSection = styled(Section)`
  padding-bottom: 0;
`;

export default ProjectsPage;
